import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { HoldingClass, Partner, Transaction } from 'types';

import { formatNumber } from 'utils/formats';
import transactionTypes from 'constants/transactionTypes';
import { useTranslate } from 'hooks/useTranslate';

type ReclassificationOperationDataRowProps = {
  index: number;
  transaction: Transaction;
};

const ReclassificationOperationTableRow: FC<
  ReclassificationOperationDataRowProps
> = ({ index, transaction }) => {
  const { t } = useTranslate();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const {
    partner,
    shareClass,
    newShareClass,
    shareFrom,
    shareTo,
    newShareFrom,
    newShareTo,
    transactionType,
  } = transaction;

  const isEntireClassReclassification =
    transactionType === transactionTypes.ENTIRE_CLASS_RECLASSIFICATION;
  const partnerId = (partner as Partner)?._id || '';
  const partnerName = (partner as Partner)?.name || '';
  const shareClassName = (shareClass as HoldingClass)?.name || '';
  const newShareClassName = (newShareClass as HoldingClass)?.name || '';

  return (
    <>
      <td className="text-left" key={`partner-name-${index}`}>
        {isEntireClassReclassification ? (
          <span>-</span>
        ) : (
          <Link
            className="text-primary"
            to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
          >
            {partnerName}
          </Link>
        )}
      </td>

      {isEntireClassReclassification ? (
        <>
          <td className="text-center tb-col-md" key={`all-ranges-${index}`}>
            {t('AllRanges')}
          </td>
          <td className="text-center tb-col-md" key={`all-ranges-to-${index}`}>
            <span>-</span>
          </td>
        </>
      ) : (
        <>
          <td className="text-center tb-col-md" key={`from-${index}`}>
            {formatNumber(shareFrom)}
          </td>

          <td className="text-center tb-col-md" key={`to-${index}`}>
            {formatNumber(shareTo)}
          </td>
        </>
      )}

      <td className="text-left tb-col-md" key={`class-name-${index}`}>
        {shareClassName}
      </td>

      {isEntireClassReclassification ? (
        <td
          className="text-center tb-col-md"
          colSpan={2}
          key={`new-from-to-${index}`}
        >
          <span>-</span>
        </td>
      ) : (
        <>
          <td className="text-center tb-col-md" key={`new-from-${index}`}>
            {formatNumber(newShareFrom)}
          </td>
          <td className="text-center tb-col-md" key={`new-to-${index}`}>
            {formatNumber(newShareTo)}
          </td>
        </>
      )}
      <td className="text-left" key={`new-class-name-${index}`}>
        {newShareClassName}
      </td>
    </>
  );
};
export default ReclassificationOperationTableRow;
